if (!customElements.get("header-popup")) {
	customElements.define(
		"header-popup",
		class HeaderPopup extends HTMLElement {
			constructor() {
				super();

				this.openButton = this.querySelector(".header-popup__open");
				this.openButton?.addEventListener("click", () => this.open());

				this.closeButton = this.querySelector(".header-popup__close");
				this.closeButton?.addEventListener("click", () => this.close());

				this.panel = document.querySelector(".header-popup__panel");
				this.updateHeaderHeight();

				this.container = this.closest(".header-formations-section");

				if (window.innerWidth < 750) {
					this.links = this.container?.querySelectorAll("a");
					this.links?.forEach((a) => {
						a.addEventListener("click", (e) => {
							const href = a.getAttribute("href");
							if (!href) return;

							e.preventDefault();
							this.close();

							if (href.startsWith("#")) {
								const target = document.querySelector(href);
								if (target) {
									const topPos =
										target.getBoundingClientRect().top + window.pageYOffset;
									const offsetPos = topPos - 70;
									window.scrollTo({
										top: offsetPos,
										behavior: "smooth",
									});
									history.pushState(null, "", href);
								}
							} else {
								window.location.href = href;
							}
						});
					});
				}
			}

			open() {
				if (!this.panel) return;

				this.openButton?.classList.add("hidden");
				this.closeButton?.classList.remove("hidden");
				this.panel.classList.add("active");
				this.updateHeaderHeight();
			}

			updateHeaderHeight() {
				this.container = this.closest(".header-formations-section");
				const root = document.documentElement;
				const containerHeight = this.container.offsetHeight;

				root.style.setProperty(
					"--header-formations-height",
					`${containerHeight}px`
				);
			}

			close() {
				if (!this.panel) return;
				this.openButton?.classList.remove("hidden");
				this.closeButton?.classList.add("hidden");
				this.panel.classList.remove("active");
			}
		}
	);
}
